import { Fragment, ReactNode } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import {clsx} from 'clsx';
import { Button} from './Button';

interface ModalProps {
  title?: string,
  isOpen: boolean,
  setIsOpen: any,
  children: ReactNode,
  onSubmit?: any
}

export const Modal = ({
  title,
  isOpen,
  setIsOpen,
  children,
  onSubmit,
}: ModalProps) => {

  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={setIsOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className={clsx('relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:p-6 sm:w-full md:max-w-2xl' +
                ' lg:max-w-3xl')}>
                { title && (
                  <Dialog.Title className="flex flex-1 font-semibold leading-6 text-xl text-neutral-950 pb-3">
                    { title }
                  </Dialog.Title>
                )}

                { children }

                { onSubmit && (
                  <div className="flex justify-end space-x-2 mt-3">
                    <Button onClick={() => setIsOpen(false)}>Cancel</Button>
                    <Button color='red' onClick={onSubmit}>Submit</Button>
                  </div>
                )}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
